export const breakpoints = {
  screen0: 768,
  screen1024: 1024,
  screen1920: 1920,
};
